import styled from "styled-components";
import { colorPalette as colors, ColorNames } from "src/theme/theme";

export const SurveyRedirectPage = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${colors[ColorNames.WHITE].hex};
`;
